import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class BarStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: props.show,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.show !== prevProps.show) {
      this.setState({
        show: this.props.show,
      });
    }
  }

  render() {
    const { name, assetBarRecord, typeChannel } = this.props;

    if (!this.state.show) {
      return null;
    }

    setTimeout(() => {
      this.setState({
        show: false,
      });
    }, 3000);

    return (
      <div className="snack-bar-container snack-bar-record">
        <div className="row" style={{ marginTop: '10px', marginLeft: '30px' }}>
          <div className="col-xs-12">
            <img
              alt=""
              className="icon-inline"
              src={assetBarRecord}
              style={{ width: 'auto', height: '20px', float: 'left' }}
            />
            <div
              className="text"
              style={{ float: 'left', fontWeight: 'bold', marginLeft: '10px' }}
            >
              {name} : {typeChannel}
            </div>
            <div className="text" style={{ float: 'left', marginLeft: '10px' }}>
              Se añadio a mis grabaciones
            </div>
          </div>
        </div>
      </div>
    );
  }
}

BarStatus.propTypes = {
  show: PropTypes.bool,
  name: PropTypes.string,
  assetBarRecord: PropTypes.string,
  typeChannel: PropTypes.string,
};
